import { List, styled } from "@mui/material";

export const MessageList = styled(List)({
  flex: 1,
  overflowY: "auto",
  padding: "16px",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0,0,0,0.2)",
    borderRadius: "3px",
  },
});
